<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <div class="my-4 display-1">Podesite novu lozinku</div>
        <v-form v-on:submit.prevent="resetPassword">
          <v-text-field v-model="password" label="lozinka" required autocomplete="new-password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click.append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"></v-text-field>
          <v-text-field v-model="confirmPassword" label="potvrda lozinke" required autocomplete="new-password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click.append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"></v-text-field>
          <v-btn class="primary" large block type="submit" :loading="loading">Sačuvaj</v-btn>
          <v-btn class="secondary" large block to="/login">login</v-btn>
          <v-alert v-if="info" :value="true" type="info" v-text="info"></v-alert>
          <v-alert v-if="error" :value="true" type="error" v-text="error"></v-alert>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import auth from '@/services/authService.js'
import { log } from '@/services/logService.js'

export default {
  data () {
    return {
      password: '',
      confirmPassword: '',
      loading: false,
      showPassword: false,
      error: '',
      info: 'Lozinka mora imati minimum 8 karaktera, malo, veliko slovo i broj'
    }
  },
  methods: {
    resetPassword () {
      if (this.password !== this.confirmPassword) {
        this.error = 'Unete lozinke moraju biti iste'
        return
      }
      let vm = this
      vm.loading = true
      const email = vm.$route.params.email
      const code = vm.$route.params.code
      const password = vm.password
      auth.resetPassword(email, code, password, function (result) {
        vm.loading = false
        log('Password is successfully updated')
        vm.info = 'Lozinka je uspešno promenjena'
        setTimeout(() => vm.$router.push('/login'), 1000)
      }, function (err) {
        vm.loading = false
        log('Password reset failed', err)
        if (err.code === 'ExpiredCodeException') {
          vm.error = 'Link je neispravan ili je već iskorišćen'
        } else {
          vm.error = 'Lozinka mora sadržati mala, velika slova i brojeve'
        }
      })
    }
  }
}

</script>

<style scoped>
</style>
